import type { FaireProductEntity } from "../../entity_types/product";

export const p_gr4eh8zxdy: FaireProductEntity = {
  token: "p_gr4eh8zxdy",
  type: "product",
  name: "Children's Tea - Organic Fairytale Dreams™ Sachets",
  brandToken: "b_5bw8e8irqb",
  brandName: "Boulder Tea Company",
  imageUrl:
    "https://cdn.faire.com/fastly/c5ab4698ddedf053bdf9db270319e50caedb4b10a7f88de7c1a188ea3e7956be.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c2d6ac5e278b673722f049644118613c012f433c255007fe646ed71ce874f8c.png",
    "https://cdn.faire.com/fastly/1335d1a8807a60d10aa38722d13d348a5e211f254022e45490b27492fb804338.png",
    "https://cdn.faire.com/fastly/3df2cafcfcb8604193eeeed9309eac4cc08c8e2089774632461c9ef47cdfe381.jpeg",
  ],
  priceDollars: 8,
  description:
    "\nThis special herbal tea is the super-mellow brew pleasant dreams are made of nightly. Relaxing organic herbs including peppermint, chamomile, linden, and lemon balm intertwine magically to create a fragrant herbal blend that both adults and the little ones will savor nightly. Adding Fairytale Dreams to your evening un-wind ritual is something you’ll look forward to all day long – and maybe even dream about lucidly …it’s naturally sweet so no need to add anything! Caffeine Free.\n\nIngredients: Chamomile (organic), Lemon Balm Leaf (organic), Linden Leaf and Flower (organic), Peppermint Leaf (organic), Stevia Leaf (organic).\n\nAmount of Tea per 6 oz water – 1 teaspoon\nWater Temperature - 212º \nTime of Steeping - 4-7 minutes\n\nIced Tea: Brew as above and chill or double the amount of tea and pour over a full glass of ice.\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:52.654Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
